module.exports = __webpack_public_path__ + "static/img/contant_9.70fa3bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/contant_9.jpg
// module id = yLTE
// module chunks = 0